"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var connect_1 = require("./connect");
exports.connect = connect_1.connect;
var connectAs_1 = require("./connectAs");
exports.connectAs = connectAs_1.connectAs;
var createConnectedStore_1 = require("./createConnectedStore");
exports.createConnectedStore = createConnectedStore_1.createConnectedStore;
var createConnectedStoreAs_1 = require("./createConnectedStoreAs");
exports.createConnectedStoreAs = createConnectedStoreAs_1.createConnectedStoreAs;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/undux/dist/src/react/index.js
// module id = 368
// module chunks = 0